// extracted by mini-css-extract-plugin
export default {"halfSection":"styles_halfSection__zlQuY","flipContent":"styles_flipContent__qxvzZ"};